import React, { useEffect, useState } from 'react';
import PrematchContext from '../../../contexts/PrematchContext';
import { classIf, getConfiguration } from '../../../data/utils';
import { useTimeline } from '../../../prematch/TimelineProvider';

export default function DaysButtonsAlt() {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const data = useTimeline();

    useEffect(() => {
        if (prematchContext.daySport && prematchContext.dayCountry && data?.weekDays) {
            const day = data.weekDays.find(d => {
                if (d.sportList?.[prematchContext.daySport]?.categories) {
                    try {
                        return Array.from(d.sportList[prematchContext.daySport].categories)?.find(c => { return c == prematchContext.dayCountry });
                    } catch (err) {
                        console.log(err);
                    }
                }
                return false;
            });
            if (day) {
                day.sport = day.sportList[prematchContext.daySport];
                prematchContext.setDaySelection(day);
            } else if (conf.seo) {
                prematchContext.openPrematchNoEvents();
            }
        }
    }, [data]);

    function handleClick48() {
        prematchContext.open48H();
    }

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}${month}${day}`;

    const reorderedDays = data.weekDays.reduce((acc, day) => {
        if (day.id === 8) {
            return [day, ...acc];
        }
        return [...acc, day];
    }, []);

    return (
        <>
            {data.weekDays &&
                <div className="filtro-settimana maiuscolo allinea-centro">
                    <a
                        className={'pointer pointer__wh pointer__wh-live'}
                        href='#/live' >Live</a>
                    {reorderedDays.map((day, i) => {
                        function handleClick() {
                            prematchContext.setDaySelection(day);
                        }
                        const selected = prematchContext.daySelection && prematchContext.daySelection.id === day.id;
                        return (
                            <a key={i}
                                href-disabled="#!"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={day.fullDesc}
                                className={'pointer pointer__wh' + classIf(selected, 'filtro-attivo-s')}
                                onClick={handleClick}
                            >{conf.iwh ? (day.id == 8 ? "+48H" : (day.date == formattedDate ? "Oggi" : day.fullDesc)) : day.desc}</a>
                        );
                    })}
                </div>
            }
        </>
    )
}
